import React from 'react';

import type { MailboxProvider } from '~/api/graphql';
import { PendingChangesSaveToast } from '~/components/settings/pending-changes-save';
import { draftsLocationName, mailClientName } from '~/lib/mailbox-providers';
import { pluralize } from '~/lib/pluralize';

/** What Move all to drafts saved, for its toast. */
export type MovedToDrafts = { count: number; fromAddress: string; provider?: MailboxProvider };

const TOAST_SHOWN_MS = 6_000;

/** Says where Move all to drafts put the emails, once it has. */
export const MovedToDraftsToast = ({ movedToDrafts }: { movedToDrafts?: MovedToDrafts }) => {
  const [isShown, setIsShown] = React.useState(!!movedToDrafts);

  React.useEffect(() => {
    if (!movedToDrafts) {
      return;
    }
    const timer = window.setTimeout(() => setIsShown(false), TOAST_SHOWN_MS);
    return () => window.clearTimeout(timer);
  }, [movedToDrafts]);

  if (!movedToDrafts) {
    return null;
  }
  const { count, fromAddress, provider } = movedToDrafts;
  return (
    <PendingChangesSaveToast
      saved={isShown}
      error={null}
      messages={{
        successTitle: `${count} ${pluralize(count, 'draft')} saved to ${mailClientName(provider)}`,
        successDescription: `They're in the ${draftsLocationName(provider)} of ${fromAddress}. Nothing was sent.`,
        errorTitle: '',
        errorDescriptionPrefix: ''
      }}
    />
  );
};
